// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInviteBulkSendBody = {
  poolId: string;
  source: "chat" | "pool";
  sourceId: string;
  selectedUserIds: string[];
};

export type typeInviteBulkSendOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    sentCount: number;
    alreadyMemberCount: number;
    alreadyInvitedCount: number;
    skippedCount: number;
  };
};

export type typeInviteBulkSendOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteBulkSendOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteBulkSendOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInviteBulkSendBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    source: { type: "string", enum: ["chat", "pool"] },
    sourceId: { type: "string", maxLength: 3000, minLength: 1 },
    selectedUserIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["poolId", "source", "sourceId", "selectedUserIds"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInviteBulkSend(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInviteBulkSendBody);
  }

  return async function postInviteBulkSend(
    payload: typeInviteBulkSendBody,
  ): Promise<typeInviteBulkSendOutput200 | typeInviteBulkSendOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInviteBulkSend" failed before calling the network. #16bfd7538246`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#16bfd7538246" },
        },
        data: null,
      } as typeInviteBulkSendOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/invite/bulk-send`,
      httpMethod: "POST",
      options,
    })) as typeInviteBulkSendOutput200 | typeInviteBulkSendOutput400;
  };
}
